import { STATUSES, ACTIONS } from '@/constants/common/message.constants'

import { type ShipmentOrderImportJobExEntity } from '../..'

/**
 * 配送依頼の取込ステータス
 */
export type ShipmentOrderImportJobStatusType =
  ShipmentOrderImportJobExEntity['status']

export const SHIPMENT_ORDER_IMPORT_JOB_STATUS_TYPE = {
  /** 処理待ち */
  PENDING: 'PENDING',
  /** 処理中 */
  IMPORTING: 'IMPORTING',
  /** 完了 */
  COMPLETED: 'COMPLETED',
  /** エラー */
  ERROR: 'ERROR',
  /** 取り消し済 */
  ROLLED_BACK: 'ROLLED_BACK',
  /** 中断 */
  SUSPENDED: 'SUSPENDED'
} as const satisfies Record<
  ShipmentOrderImportJobStatusType,
  ShipmentOrderImportJobStatusType
>

export const SHIPMENT_ORDER_IMPORT_JOB_STATUS_TYPE_LABEL = {
  [SHIPMENT_ORDER_IMPORT_JOB_STATUS_TYPE.PENDING]: STATUSES.PENDING,
  [SHIPMENT_ORDER_IMPORT_JOB_STATUS_TYPE.IMPORTING]: STATUSES.IMPORTING,
  [SHIPMENT_ORDER_IMPORT_JOB_STATUS_TYPE.COMPLETED]: STATUSES.COMPLETED,
  [SHIPMENT_ORDER_IMPORT_JOB_STATUS_TYPE.ERROR]: STATUSES.FAILED,
  [SHIPMENT_ORDER_IMPORT_JOB_STATUS_TYPE.ROLLED_BACK]: STATUSES.ROLLED_BACK,
  [SHIPMENT_ORDER_IMPORT_JOB_STATUS_TYPE.SUSPENDED]: ACTIONS.INTERRUPT
} as const satisfies Record<ShipmentOrderImportJobStatusType, string>
